import { render, staticRenderFns } from "./mov_inv.vue?vue&type=template&id=3cc5b306&"
import script from "./mov_inv.vue?vue&type=script&lang=js&"
export * from "./mov_inv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports